import React from "react";
import { Route } from "react-router";
import Webhooks from "pages/webhooks/main";
import EditWebhook from "pages/webhooks/edit";
import AuthRoute from "helpers/authentication/authRoute";

const WebhookRoutes = () => (
    <>
        <Route
            path="/webhooks"
            element={
                <AuthRoute>
                    <Webhooks />
                </AuthRoute>
            }
        />
        <Route
            path="/webhooks/:id"
            element={
                <AuthRoute>
                    <EditWebhook />
                </AuthRoute>
            }
        />
    </>
);

export default WebhookRoutes;
